package org.gstechnovos.jexonplastech.components.cms

// Import all your section components and data classes
import androidx.compose.runtime.Composable
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaData
import org.gstechnovos.jexonplastech.sections.about.sections.*
import org.gstechnovos.jexonplastech.sections.contact.sections.*
import org.gstechnovos.jexonplastech.sections.home.sections.*
import org.gstechnovos.jexonplastech.sections.products.sections.*

// 1. The Sealed Class: Represents the JSON array objects coming from your CMS
sealed class CmsSection {
    // Home Page Sections
    data class HomeHeroSection(val data: HomeHeroSectionData = defaultHeroSectionData) : CmsSection()
    data class HomeCompanyOverviewSection(val data: HomeCompanyOverviewData = defaultCompanyOverviewData) : CmsSection()
    data class HomeFeaturedCategoriesSection(val data: HomeFeaturedCategoriesData = defaultFeaturedCategoriesData) :
        CmsSection()

    data class HomeQualityStandardsSection(val data: HomeQualityStandardsData = defaultQualityStandardsData) :
        CmsSection()

    data class HomeGlobalCtaSection(val data: GlobalCtaData = defaultHomeCtaData) : CmsSection()

    // About Page Sections
    data class AboutHeroSection(val data: AboutHeroData = defaultAboutHeroData) : CmsSection()
    data class AboutStorySection(val data: AboutStoryData = defaultAboutStoryData) : CmsSection()
    data class AboutExecutivesSection(val data: AboutExecutivesData = defaultAboutExecutivesData) : CmsSection()
    data class AboutCapabilitiesSection(val data: AboutCapabilitiesData = defaultAboutCapabilitiesData) : CmsSection()
    data class AboutCoreValuesSection(val data: AboutCoreValuesData = defaultAboutCoreValuesData) : CmsSection()
    data class AboutCtaSection(val data: GlobalCtaData = defaultAboutCtaData) : CmsSection()

    // Products Page Sections
    data class ProductsHeaderSection(val data: ProductsHeaderData = defaultProductsHeaderData) : CmsSection()
    class ProductsCatalogSection : CmsSection()
    data class ProductsFilterSection(val data: ProductsFilterData = defaultProductsFilterData) : CmsSection()
    data class ProductsGridSection(val data: ProductsGridData = defaultProductsGridData) : CmsSection()
    data class ProductsCtaSection(val data: GlobalCtaData = defaultProductsCtaData) : CmsSection()

    // Contact Page Sections
    data class ContactHeaderSection(val data: ContactHeaderData = defaultContactHeaderData) : CmsSection()
    data class ContactInfoSection(val data: ContactInfoData = defaultContactInfoData) : CmsSection()
    data class ContactFormSection(val data: ContactFormData = defaultContactFormData) : CmsSection()
}

// 2. The Renderer: Acts as a switchboard to render the correct UI for the CMS data block
@Composable
fun DynamicSectionRenderer(section: CmsSection) {
    when (section) {
        // Home
        is CmsSection.HomeHeroSection -> HomeHeroSection(data = section.data)
        is CmsSection.HomeCompanyOverviewSection -> HomeCompanyOverviewSection(data = section.data)
        is CmsSection.HomeFeaturedCategoriesSection -> HomeFeaturedCategoriesSection(data = section.data)
        is CmsSection.HomeQualityStandardsSection -> HomeQualityStandardsSection(data = section.data)
        is CmsSection.HomeGlobalCtaSection -> HomeGlobalCtaSection(data = section.data)

        // About
        is CmsSection.AboutHeroSection -> AboutHeroSection(data = section.data)
        is CmsSection.AboutStorySection -> AboutStorySection(data = section.data)
        is CmsSection.AboutExecutivesSection -> AboutExecutivesSection(data = section.data)
        is CmsSection.AboutCapabilitiesSection -> AboutCapabilitiesSection(data = section.data)
        is CmsSection.AboutCoreValuesSection -> AboutCoreValuesSection(data = section.data)
        is CmsSection.AboutCtaSection -> AboutCtaSection(data = section.data)

        // Products
        is CmsSection.ProductsHeaderSection -> ProductsHeaderSection(data = section.data)
        is CmsSection.ProductsCatalogSection -> ProductsCatalogSection()
        is CmsSection.ProductsFilterSection -> {}
        is CmsSection.ProductsGridSection -> {}
        is CmsSection.ProductsCtaSection -> ProductsCtaSection(data = section.data)

        // Contact
        is CmsSection.ContactHeaderSection -> ContactHeaderSection(data = section.data)
        is CmsSection.ContactInfoSection -> ContactInfoSection(data = section.data)
        is CmsSection.ContactFormSection -> ContactFormSection(data = section.data)
    }
}